import axios from 'axios/index';

function getListOfAvailableCountries(okCallback, koCallback) {
    return axios.get('/openai/countries/all')
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });

}

function createConversation(countryStringId, okCallback, koCallback) {
    const params = countryStringId ? "?countryStringId=" + countryStringId : "";
    return axios.get('/openai/createConversation' + params)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });

}

function getInternetSearchQuery(conversationId, okCallback, koCallback) {
    return axios.get(`/openai/${conversationId}/internetSearchQuery`)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function sendMessageAndRetrieveResponseFromAssistant(userMessage, okCallback, koCallback) {
    return axios.post('/openai/sendMessage', userMessage)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function getConversationWithMessagesListForConversationId(conversationId, okCallback, koCallback) {
    return axios.get('/openai/getConvWithMessages/' + conversationId)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function getNumberOfCompletesForSurveyId(surveyId, okCallback, koCallback) {
    return axios.get('/openai/count/respondents/completed/' + surveyId)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
                koCallback && koCallback(error.response);
            }
        );
}

function createAndStartSurvey (conversationId, survey, okCallback, koCallback) {
    return axios.post('/openai/launchSurvey/' + conversationId, survey)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
                koCallback && koCallback(error.response);
            }
        );
}

function transcribeAudioFile(audioFile, requestTimestamp, okCallback, koCallback) {
    let formData = new FormData();
    formData.append('file', audioFile);
    return axios.post('/openai/transcribeAudio', formData, {
        headers: {
            'request-timestamp': requestTimestamp
        }
    })
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
                koCallback && koCallback(error.response);
            }
        );
}

function getCintEstimates(conversationId, survey, okCallback, koCallback) {
    return axios.post('/openai/estimates/' + conversationId, survey)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function getSurveyDocument(conversationId, okCallback, koCallback) {
    return axios.get('/openai/getConversationSurveyDocx/' + conversationId, {
        responseType: 'blob'
    }).then((response) => {
        okCallback && okCallback(response);
    })
    .catch((error) => {
        koCallback && koCallback(error.response);
    });
}



export default {
    getListOfAvailableCountries,
    createConversation,
    getInternetSearchQuery: getInternetSearchQuery,
    sendMessageAndRetrieveResponseFromAssistant,
    getConversationWithMessagesListForConversationId,
    getNumberOfCompletesForSurveyId,
    createAndStartSurvey,
    transcribeAudioFile,
    getCintEstimates,
    getSurveyDocument
};